import announcementsPlugin from '@backstage-community/plugin-announcements/alpha';
import { compatWrapper } from '@backstage/core-compat-api';
import { AnnouncementBanner } from '../components/announcements/AnnouncementBanner';

const announcementsFeature = announcementsPlugin.withOverrides({
  extensions: [
    announcementsPlugin
      .getExtension('app-root-element:announcements/banner')
      .override({
        factory(originalFactory) {
          return originalFactory({
            params: { element: <AnnouncementBanner /> },
          });
        },
      }),
    announcementsPlugin.getExtension('page:announcements').override({
      factory(originalFactory) {
        return originalFactory({
          params: {
            path: '/announcements',
            routeRef: announcementsPlugin.routes.root,
            noHeader: true,
            loader: async () => {
              const { AdminAnnouncementsPage } = await import(
                '../components/announcements/AdminAnnouncementsPage'
              );
              return compatWrapper(<AdminAnnouncementsPage />);
            },
          },
        });
      },
    }),
    announcementsPlugin
      .getExtension('entity-card:announcements/announcements')
      .override({ disabled: true }),
  ],
});

export default announcementsFeature;
